import useMutationApi from '../useMutationApi';

export interface SendTableEmailParams {
  to: string[];
  cc?: string[];
  bcc?: string[];
  subject: string;
  body: string;
  csvContent: string;
  filename: string;
}

export interface SendTableEmailResponse {
  message: string;
}

export function useSendTableEmail() {
  return useMutationApi<SendTableEmailParams, SendTableEmailResponse>({
    endpoint: 'rebates/send-table-email',
    method: 'POST',
    successMessage: 'Email sent successfully',
  });
}

export default useSendTableEmail;
